import { API_URL } from '@/api/url';
import { Http } from '@/lib/http';
import {
  DiscountSettingParams,
  UpdateProductParams,
  DiscountSettingDetailParams,
  DiscountSettingDetailRes,
  DiscountTemplateValidationResponse,
  ValidateDiscountTemplateParams
} from '@/types/index.d';

class DiscountSettingApi {
  /**
   * 获取油站折扣列表
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/844072
   */
  static getDiscountSettingList = (params: DiscountSettingParams) => {
    return Http({
      resLatest: API_URL.GetDiscountSettingList,
      method: 'GET',
      url: API_URL.GetDiscountSettingList,
      params
    });
  };

  /**
   * 获取折扣详情
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/844078
   */
  static getDiscountSettingDetail = (params: DiscountSettingDetailParams) => {
    return Http<DiscountSettingDetailRes>({
      method: 'GET',
      url: API_URL.GetDiscountSettingDetail,
      params
    });
  };

  /**
   * 保存油站折扣
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/844088
   */
  static saveDiscount = (params: any) => {
    return Http({
      method: 'POST',
      url: API_URL.SaveDiscount,
      data: params
    });
  };

  /**
   * 油品上下架
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/844097
   */
  static updateProduct = (params: UpdateProductParams) => {
    return Http({
      method: 'POST',
      url: API_URL.UpdateProduct,
      data: params
    });
  };

  /**
   * 下载excel
   * @link
   */
  static downloadDiscountTemplate = (params: { station_list: string; product_list: string }) => {
    return Http({
      method: 'GET',
      url: API_URL.DownloadDiscountTemplate,
      params,
      responseType: 'blob',
      isDownload: true
    });
  };

  /**
   * 校验excel，要上传文件又要下载文件
   * @link
   */
  static validateDiscountTemplate = (params: ValidateDiscountTemplateParams) => {
    return Http<DiscountTemplateValidationResponse | Blob>({
      method: 'POST',
      url: API_URL.ValidateDiscountTemplate,
      data: params,
      headers: {
        'content-type': 'multipart/form-data'
      },
      responseType: 'blob',
      isDownload: true,
      errorToast: false
    });
  };

  /**
   * 批量修改折扣预览
   * @link
   */
  static getProductInfoList = (params: { product_id_list: string }) => {
    return Http<{
      total: number;
      list: {
        original_price: string;
        discount_before: string;
        product_id: number;
      }[];
    }>({
      method: 'GET',
      url: API_URL.GetProductInfoList,
      params
    });
  };

  /**
   * 二次确认修改折扣&消息触达
   * @link
   */
  static batchSaveDiscount = (params: any) => {
    return Http<any>({
      method: 'POST',
      url: API_URL.BatchSaveDiscount,
      data: params,
      headers: {
        'content-type': 'multipart/form-data'
      },
      responseType: 'blob',
      isDownload: true
    });
  };

  /**
   * 二次确认修改折扣&消息触达
   * @link
   */
  static getDiscountManageSwitch = (params: any) => {
    return Http<any>({
      method: 'GET',
      url: API_URL.GetDiscountManageSwitch,
      params,
      errorToast: false
    });
  };
}

export default DiscountSettingApi;
